import React from 'react';
import { useTranslation } from 'react-i18next';
import Styles from '../../scss/enabled.module.scss';


interface IDisabledEnabledItemProps {
    enabled: boolean;
}


export function DisabledEnabledItem({
    enabled
}: IDisabledEnabledItemProps) {
    const { t } = useTranslation();
    return <div className={Styles.enabledDiv}>{enabled ? <div className={Styles.enabled}>
        {t("misc.enabled")}
    </div> : <div className={Styles.disabled}>
            {t("misc.disabled")}
        </div>}
    </div>;

}